import axiosInstance from 'src/services/common/axiosInstance'
import { API_ROUTES } from 'src/services/common/routes'

export const getVoiceList = async (id, page, order = 'asc') => {
  try {
    const res = await axiosInstance.get(API_ROUTES.Character.voiceList.replace(':character_id', id), {
      params: {
        page,
        order
      }
    })
    return res.data
  } catch (error) {
    console.log(error)
    return false
  }
}
